import * as React from 'react';

import { cn } from '@playbooks/ui/lib/utils';

const DisplaySection = ({ className = '', ...props }: React.ComponentProps<'section'>) => {
	// Theme
	const rootClassName = cn('relative w-full py-10 md:py-14', className);

	// Render
	return <section className={rootClassName} {...props} />;
};

const DisplaySectionHeader = ({ className = '', ...props }: React.ComponentProps<'header'>) => {
	// Theme
	const rootClassName = cn('mx-auto flex-column w-full max-w-3xl gap-4 px-4 pb-8', className);

	// Render
	return <header className={rootClassName} {...props} />;
};

const DisplaySectionBody = ({ className = '', ...props }: React.ComponentProps<'div'>) => {
	// Theme
	const rootClassName = cn('w-full px-4', className);

	// Render
	return <div className={rootClassName} {...props} />;
};

const DisplaySectionFooter = ({ className = '', ...props }: React.ComponentProps<'footer'>) => {
	// Theme
	const rootClassName = cn('flex-between w-full gap-3 px-4 pt-8', className);

	// Render
	return <footer className={rootClassName} {...props} />;
};

export { DisplaySection, DisplaySectionBody, DisplaySectionFooter, DisplaySectionHeader };
